










import { getCardColor } from '@/main';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop()
  variant?: string;

  getColor() {
    return getCardColor(this.variant);
  }
}
